module.exports = __webpack_public_path__ + "media/images/project/check-mark-green-c502b598277ffa613b4e8aafaa8d3127.svg";